import React from 'react';
import { motion } from 'framer-motion';
import { 
  MessageSquare, 
  Calendar, 
  Bell, 
  Heart, 
  HelpCircle, 
  Users
} from 'lucide-react';
import { features } from '../../data/mock';

const iconComponents = {
  MessageSquare,
  Calendar,
  Bell,
  Heart,
  HelpCircle,
  Users
};

const Features = () => {
  return (
    <section id="beneficios" className="py-12 lg:py-16 px-4" style={{ background: 'var(--bg-page)' }}>
      <div className="container mx-auto max-w-7xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <span className="section-tag">BENEFÍCIOS</span>
          <h2 className="heading-1 mb-4">
            Tudo que você precisa em um só lugar
          </h2>
          <p className="body-large max-w-2xl mx-auto">
            Nossa IA foi desenvolvida especialmente para consultórios médicos, entendendo as necessidades da rotina do consultório.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => {
            const Icon = iconComponents[feature.icon];
            return (
              <motion.div
                key={feature.id}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="feature-card"
              >
                <div 
                  className="feature-icon"
                  style={{ background: 'var(--brand-gradient)' }}
                >
                  <Icon className="w-7 h-7" />
                </div>
                
                <h3 className="heading-2 mb-3">{feature.title}</h3>
                <p className="body-medium">{feature.description}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Features;
